import styled from 'styled-components';
import AkSelect from '@atlaskit/select';
import { Country as CountryType } from '../../data/countries/model';
import React, { useEffect, useState } from 'react';
import { Field } from '@atlaskit/form';
import t from '../../i18n/intl';
import { createFilter } from 'react-select';
import { colors } from '@atlaskit/theme';
import config from '../../../appconfig';
import { FormattedMessage } from 'react-intl';

export const Select = styled(AkSelect)`
  input::-webkit-contacts-auto-fill-button {
    display: none !important;
  }
`;

const CurrencyChargedIn = styled.div`
  font-size: 10pt;
  color: ${colors.N80};
`;

type Props = {
  country: string;
  countries: CountryType[];
  onSelectCountry: (country: CountryType | null) => void;
  hasReconcilableWarning?: boolean;
  hasIrreconcilableWarning?: boolean;
};

const aliases = {
  US: 'USA U.S.A.',
  GB: 'UK U.K. Great Britain England Wales Scotland',
};

const stringify = (option) => `${option.value} ${option.label} ${aliases[option.value] || ''}`;

export const Country = ({
  countries,
  country,
  onSelectCountry,
  hasIrreconcilableWarning,
  hasReconcilableWarning,
}: Props) => {
  const preselectedCountry =
    countries.find((c) => c.displayName?.toLowerCase() === country?.toLowerCase()) || null;
  const [countryValue, setCountryValue] = useState<CountryType | null>(preselectedCountry);

  useEffect(() => {
    setCountryValue(preselectedCountry);
    onSelectCountry(preselectedCountry);
  }, [country]);

  const handleChange = (c) => {
    setCountryValue(c);
    onSelectCountry(c);
  };

  return (
    <Field
      name="country"
      label={t('mac.edit-details.org.contact.country')}
      isRequired
      validate={handleChange}
      defaultValue={countryValue}
      testId="mac-edit-billing-details-country"
    >
      {({ fieldProps }) => (
        <>
          <Select
            hasAutocomplete
            options={countries}
            getOptionLabel={(c) => c.displayName}
            getOptionValue={(c) => c.isoCountryCode}
            filterOption={createFilter({ stringify })}
            {...fieldProps}
          />
          {hasIrreconcilableWarning && (
            <CurrencyChargedIn>
              <FormattedMessage
                id="mac.edit-details.org.contact.irreconcilable.warning"
                values={{
                  inputedCountry: countryValue?.displayName,
                  contactUs: (
                    // eslint-disable-next-line react/jsx-no-target-blank
                    <a href={config.companyContact} target="_blank">
                      <FormattedMessage id="common.contact-us" />
                    </a>
                  ),
                }}
              />
            </CurrencyChargedIn>
          )}
          {hasReconcilableWarning && (
            <CurrencyChargedIn>
              <FormattedMessage
                id="mac.edit-details.org.contact.reconcilable.warning"
                values={{
                  currencyCode: countryValue?.primaryCurrency || '',
                }}
              />
            </CurrencyChargedIn>
          )}
        </>
      )}
    </Field>
  );
};
